import React, { useState, useEffect } from 'react'
import useMedia from '@/hook/useMedia'

import MagazineIssueModal from '../MagazineIssueModal'
import ViewSelector from './component/ViewSelector'
import MagazineViewer from './component/MagazineViewer'
import { bool } from 'prop-types'

const IssueMagazineViewer = (props) => {
  const { isDesktop } = props
  const isDesktopClient = useMedia('(min-width: 960px)')
  const [displayModal, setDisplayModal] = useState(isDesktop)

  const [isFullScreen, setFullScreen] = useState(false)
  const [viewModeChosen, setViewModeChosen] = useState(false)

  /* eslint-disable */
  useEffect(() => {
    !viewModeChosen &&
      document.body.classList.add('has-locked-scrolling-desktop')
    return document.body.classList.remove('has-locked-scrolling-desktop')
  }, [])
  /* eslint-enable */

  useEffect(() => {
    if (isDesktopClient !== isDesktop) setDisplayModal(isDesktopClient)
  }, [isDesktopClient, isDesktop])

  return (
    <>
      {isFullScreen && (
        <MagazineIssueModal
          onClose={() => {
            document.body.classList.remove('has-locked-scrolling-desktop')
            setFullScreen(false)
          }}
        >
          <MagazineViewer isFullScreen {...props} />
        </MagazineIssueModal>
      )}
      {!isFullScreen && <MagazineViewer {...props} />}
      {!viewModeChosen && displayModal && (
        <MagazineIssueModal
          onClose={() => {
            document.body.classList.remove('has-locked-scrolling-desktop')
            setViewModeChosen(true)
          }}
          compact
        >
          <ViewSelector
            setFullScreen={setFullScreen}
            setViewModeChosen={setViewModeChosen}
          />
        </MagazineIssueModal>
      )}
    </>
  )
}

IssueMagazineViewer.propTypes = {
  isDesktop: bool
}

export default IssueMagazineViewer
